import { render, staticRenderFns } from "./Tab5.vue?vue&type=template&id=5b8cde6f&scoped=true"
import script from "./Tab5.vue?vue&type=script&lang=js"
export * from "./Tab5.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=5b8cde6f&prod&scoped=true&lang=css&external"
import style1 from "./Tab5.vue?vue&type=style&index=1&id=5b8cde6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8cde6f",
  null
  
)

export default component.exports